<template>
  <CCol sm="12" class="new-message-main">
    <CRow>
      <CCol sm="8" class="border-right" style="display: grid">
        <CCol sm="12" class="p-0">

          <CRow class="d-flex align-center">
            <CCol sm="6">
              <div class="positon-relative message-select">
                <label for>Select Role</label>
                <select v-model="role" name id class="form-control" @change="reset()">
                  <option value>Select</option>
                  <option value="patient">Patient</option>
                  <option value="doctor">Doctor</option>
                  <option value="pharmacy">Pharmacy</option>
                  <option value="diagnostics-lab">Diagnostic</option>
                  <option value="bloodbank">Blood Bank</option>
                  <option value="ambulance">Ambulance</option>
                </select>
                <span class="drop-icon">
                  <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
                </span>
              </div>
            </CCol>
            <CCol sm="6" class="check-chat">
              <v-checkbox v-model="checkChat" outline hide-details class="checkBox-stye"
                :label="`Send as Chat`"></v-checkbox>
            </CCol>

            <CCol sm="6" class="check-chat">
              <v-checkbox v-model="checkSms" outline hide-details class="checkBox-stye"
                :label="`Send as sms`"></v-checkbox>
            </CCol>
          </CRow>
          <CCol sm="12">
            <div>
              <label for>Applied Filters</label>
            </div>

            <v-chip class="text-capitalize" v-for="(filter, i) in selectUser" :key="i" label close @click:close="
              selectUser.splice(index, 1);
            removeFilter(index, i);
            ">
              <span>{{ filter.full_name }}</span>
            </v-chip>
            <div class="chip-list" v-if="Object.keys(appliedFilters).length > 0">
              <span v-for="(appliedFilter, index) in appliedFilters" :key="index">
                <v-chip class="text-capitalize" label close v-if="index == 'is_verified'"
                  @click:close="removeFilter(index)">{{ appliedFilter ? "Verified" : "Non Verified" }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'gender'"
                  @click:close="removeFilter(index)">{{ appliedFilter }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'is_relife_member'"
                  @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Relife Memeber"
                    : "Non Relife Memeber"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'is_generic_store'"
                  @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Generic Store"
                    : "Non Generic Store"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'pharmacy_service_mode'"
                  @click:close="removeFilter(index)">{{ appliedFilter }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'hospital_delivery'"
                  @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Hospital Delivery"
                    : "Hospital Delivery Not Available"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'donor_card'"
                  @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Donor Card Accepted"
                    : "Donor Card Not Accepted"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'diagnostic_service_mode'"
                  @click:close="removeFilter(index)">{{ appliedFilter }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'type_of_medicine'"
                  v-for="(medicine, i) in appliedFilter" :key="i" @click:close="removeFilter(index, i)">{{ medicine
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'working_hour'"
                  @click:close="removeFilter(index)">{{ appliedFilter }}</v-chip><v-chip class="text-capitalize" label
                  close v-else-if="index == 'is_attach_to_hospital'" @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Attached To Hospital"
                    : "Not Attached To Hospital"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'outstation'"
                  @click:close="removeFilter(index)">{{
                    appliedFilter == true
                    ? "Outstation Service"
                    : "Not Outstation Service"
                  }}</v-chip>
                <v-chip class="text-capitalize" label close v-else-if="index == 'ambulance_type'"
                  @click:close="removeFilter(index)">{{ appliedFilter }}</v-chip>
                <!-- <v-chip
                  class="text-capitalize"
                  label
                  close
                  v-else-if="index == 'ambulance_service_details'"
                  v-for="(ambulance_service, i) in appliedFilter"
                  :key="i"
                  @click:close="removeFilter(index, i)"
                  >{{ ambulance_service }}</v-chip
                > -->

                <v-chip v-else class="text-capitalize" v-for="(filter, i) in appliedFilter" :key="i" label close
                  @click:close="removeFilter(index, i)">
                  <span v-if="index == 'specialities'">{{
                    filter.speciality_type
                  }}</span>
                  <span v-else>{{ filter }}</span>
                </v-chip>
              </span>
            </div>
            <div class="chip-list mt-0" v-else>No filters are selected</div>
            <div>
              <small>Your messages will be sent according to the applied
                filers.</small>
            </div>
          </CCol>
          <CCol sm="12">
            <label for>Message</label>
            <!-- <v-textarea outlined rows="3" v-model="message"></v-textarea> -->
            <editor :model-value="message" :uploadType="'url'" @update:modelValue="updateMessage" @uploadedFile="(url) => {
              uploadedFile = url;
            }
              " />

            <small v-if="userCount > 0">
              This message will be notified to
              <strong>{{ userCount }}</strong> users
            </small>
            <small v-else>
              <strong class="text-danger">No users was found with this filters</strong>
            </small>
          </CCol>
          <CCol v-if="uploadedFile">
            <v-chip close @click:close="uploadedFile = ''" label outlined>
              <img v-if="checkIsPdf(uploadedFile)" src="/img/avatars/file-pdf.png" alt="default-user" class="mr-2"
                style="width:22px;" />
              <img v-else src="/img/avatars/014-gallery.png" alt="default-user" class="mr-2" style="width:22px;" />
              {{ getFilenameFromURL(uploadedFile) }}
            </v-chip>
          </CCol>
        </CCol>
        <CCol v-if="permissions.includes('CAN_SEND_PUSH_NOTIFICATION')" sm="12" class="d-flex justify-content-end">
          <v-btn class="sub-height" color="success" :disabled="message == '' || userCount == 0"
            @click="sendNotification()">Submit</v-btn>
        </CCol>
      </CCol>
      <!-- ...... end col-8 .... -->
      <CCol sm="4" class="p-0">
        <div class="filters-head-div px-0 pt-0 align-items-center justify-content-between">
          <!-- <div class="d-flex align-items-center">
            <filterSVG />
            <h6 class="mb-0">Filter</h6>
          </div> -->

          <v-tabs v-model="tabs" background-color="transparent" class="border-bottom">
            <v-tab v-for="item in filterItems" :key="item">{{
              item.tabName
            }}</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs">
            <!-- .......... new message ......... -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div v-if="tabs == 0">
                    <CRow>
                      <CCol sm="12" class="px-0" v-if="reRender">
                        <CCol sm="12" class="pt-0" v-if="role == 'doctor'">
                          <label for>Branch of Medicine</label>
                          <v-select v-model="branchOfMedicines" :items="medicineBranches" outlined
                            placeholder="Select Branch of Medicine" multiple @change="
                              filterChanged(
                                'branch_of_medicine',
                                branchOfMedicines
                              )
                              ">
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 5" label>
                                <span>{{ item }}</span>
                              </v-chip>
                              <span v-if="index >= 5" class="grey--text caption">(+{{
                                branchOfMedicines.length - 5
                              }}
                                others)</span>
                            </template>
                          </v-select>
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'doctor'">
                          <label for>Qualification</label>
                          <v-select v-model="qualifications" :items="doctorQualifications" outlined
                            placeholder="Select Qualification" multiple @change="
                              filterChanged('qualification', qualifications)
                              ">
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 5" label>
                                <span>{{ item }}</span>
                              </v-chip>
                              <span v-if="index >= 5" class="grey--text caption">(+{{ qualifications.length - 5 }}
                                others)</span>
                            </template>
                          </v-select>
                        </CCol>
                        <CCol sm="12 pt-0" v-if="role == 'doctor'">
                          <label for>Speciality</label>
                          <v-select v-model="specialities" :items="doctorSpecialities" item-text="speciality_type"
                            item-value="speciality_id" outlined multiple placeholder="Select Speciality" @change="
                              filterChanged('specialities', specialities)
                              " return-object>
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index === 0" label>
                                <span>{{ item.speciality_type }}</span>
                              </v-chip>
                              <span v-if="index === 1" class="grey--text caption">(+{{ specialities.length - 1 }}
                                others)</span>
                            </template>
                          </v-select>
                        </CCol>
                        <CCol sm="12" class="pt-0">
                          <label for>Location</label>
                          <v-select v-model="locations" :items="userLocations" attach multiple
                            placeholder="Select Location" outlined @change="filterChanged('location', locations)">
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-list-item-content class="p-0">
                                  <v-text-field v-model="searchTerm" placeholder="Search" @input="searchLocations"
                                    class="pt-0"></v-text-field>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-0"></v-divider>
                            </template>
                          </v-select>
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role != 'patient' && role != 'doctor'">
                          <label for>Relife Member</label>
                          <v-select v-model="isRelifeMember" :items="singleSelectOption" item-text="name"
                            item-value="value" cache-items outlined attach hide-details @change="
                              filterChanged('is_relife_member', isRelifeMember)
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'pharmacy'">
                          <label for>Generic Store</label>
                          <v-select v-model="isGeneric" :items="singleSelectOption" item-text="name" item-value="value"
                            cache-items outlined attach hide-details @change="
                              filterChanged('is_generic_store', isGeneric)
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'pharmacy'">
                          <label for>Mode of service</label>
                          <v-select v-model="pharmacyServiceMode" :items="pharmacyServiceModeItem" item-text="name"
                            item-value="value" cache-items outlined attach hide-details @change="
                              filterChanged(
                                'pharmacy_service_mode',
                                pharmacyServiceMode
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'diagnostics-lab'">
                          <label for>Mode of service</label>
                          <v-select v-model="diagnosticServiceMode" :items="diagnosticServiceModeItem" item-text="name"
                            item-value="value" cache-items outlined attach hide-details @change="
                              filterChanged(
                                'diagnostic_service_mode',
                                diagnosticServiceMode
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'diagnostics-lab'">
                          <label for>Diagnostic service type</label>
                          <v-select v-model="diagnosticServiceType" placeholder="Select service type"
                            :items="diagnosticServiceTypeItem" item-text="name" item-value="value" multiple small-chips
                            cache-items outlined attach hide-details @change="
                              filterChanged(
                                'diagnostic_services_offered',
                                diagnosticServiceType
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'bloodbank'">
                          <label for>Components Available</label>
                          <v-select v-model="bloodBankComponent" placeholder="Select Components Type"
                            :items="bloodBankComponentItem" item-text="name" item-value="value" multiple small-chips
                            cache-items outlined attach hide-details @change="
                              filterChanged(
                                'bloodbank_services_offered',
                                bloodBankComponent
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'ambulance'">
                          <label for>Ambulance Type</label>
                          <v-select v-model="ambulanceType" placeholder="Select Ambulance Type" :items="ambulanceTypeItem"
                            item-text="name" item-value="value" multiple small-chips cache-items outlined attach
                            hide-details @change="
                              filterChanged(
                                'ambulance_service_details',
                                ambulanceType
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'ambulance'">
                          <label for>Attached to Hospital</label>
                          <v-select v-model="attachToHospital" :items="singleSelectOption" item-text="name"
                            item-value="value" cache-items outlined attach hide-details @change="
                              filterChanged(
                                'is_attach_to_hospital',
                                attachToHospital
                              )
                              " />
                        </CCol>

                        <CCol sm="12" class="pt-0" v-if="role == 'ambulance'">
                          <label for>Outstation Service</label>
                          <v-select v-model="outStationService" :items="singleSelectOption" item-text="name"
                            item-value="value" small-chips cache-items outlined attach hide-details @change="
                              filterChanged('outstation', outStationService)
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'ambulance'">
                          <label for>Ambulance service - Paid / Free</label>
                          <v-select v-model="ambulanceServiceType" :items="[
                            { name: 'All', value: '' },
                            { name: 'Paid', value: 'Paid' },
                            { name: 'Free', value: 'Free' },
                          ]" item-text="name" item-value="value" small-chips cache-items outlined attach hide-details
                            @change="
                              filterChanged(
                                'ambulance_type',
                                ambulanceServiceType
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'bloodbank'">
                          <label for>Accepts Donor Cards</label>
                          <v-select v-model="donorCard" :items="singleSelectOption" item-text="name" item-value="value"
                            cache-items outlined attach hide-details @change="filterChanged('donor_card', donorCard)" />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'bloodbank'">
                          <label>Hospital Delivery </label>
                          <v-select v-model="hospitalDelivery" :items="singleSelectOption" item-text="name"
                            item-value="value" cache-items outlined attach hide-details @change="
                              filterChanged(
                                'hospital_delivery',
                                hospitalDelivery
                              )
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role != 'patient' && role != 'doctor'">
                          <label for>Working Hour</label>
                          <v-select v-model="workingHour" :items="workingHourOption" item-text="name" item-value="value"
                            cache-items outlined attach hide-details
                            @change="filterChanged('working_hour', workingHour)" />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'doctor'">
                          <label for>Verified/Nonverified</label>
                          <v-select v-model="userStatus" :items="userStatusOption" item-text="name" item-value="value"
                            cache-items outlined attach hide-details />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'pharmacy' ||
                          role == 'diagnostics-lab' ||
                          role == 'bloodbank'
                          ">
                          <label for>Ownership Type</label>
                          <v-select v-model="centerOwnership" placeholder="Select Ownership Type"
                            :items="centerOwnershipItems" item-text="name" item-value="value" multiple small-chips
                            cache-items outlined attach hide-details @change="
                              filterChanged('ownership_type', centerOwnership)
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'pharmacy'">
                          <label for>Pharmacy Type</label>
                          <v-select v-model="pharmacyType" placeholder="Select Pharmacy Type" :items="pharmacyTypesItems"
                            item-text="name" item-value="value" multiple small-chips cache-items outlined attach
                            hide-details @change="
                              filterChanged('type_of_medicine', pharmacyType)
                              " />
                        </CCol>
                        <CCol sm="12" class="pt-0" v-if="role == 'patient'">
                          <label for>Gender</label>
                          <select v-model="gender" name id class="form-control h-50px"
                            @change="filterChanged('gender', gender)">
                            <option value="">All</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                        </CCol>
                      </CCol>
                    </CRow>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- .......... end new message ......... -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div v-if="tabs == 1">
                    <CRow>
                      <CCol sm="12" class="pt-3">
                        <label for>Search Users</label>
                        <v-autocomplete v-model="selectUser" :items="users" :loading="isLoading"
                          :search-input.sync="search" hide-no-data item-text="full_name" item-value="_id"
                          label="Search User" return-object outlined multiple class="import-combo">
                        </v-autocomplete>

                        <!-- <span class="d-block pt-3">
                            <v-chip
                              class="text-capitalize"
                              label
                              close
                              >asdasd</v-chip>
                          </span> -->
                      </CCol>
                    </CRow>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- .......... end sent messages ......... -->
          </v-tabs-items>
          <a v-if="Object.keys(appliedFilters).length > 0" @click="clearFilter()" class="pl-7">clear filters</a>
        </div>
      </CCol>
      <!-- ........ end col-4 ......... -->
    </CRow>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="border-bottom lighten-2">Applied Filters</v-card-title>

        <v-card-text class="p-3">
          <v-chip class="text-capitalize" v-for="(appliedFilter, index) in appliedFilters" :key="index" label close>{{
            appliedFilter.value }}</v-chip>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined text @click="dialog = false">Close</v-btn>
          <v-btn color="green" dark>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </CCol>
</template>
<script>
import "@/assets/scss/_systemNotifications.scss";
import { pickSvg } from "@/views/SVG";
import medicineBranches from "@/data/medicineBranches";
import doctorQualifications from "@/data/doctorQualifications";
import config from "@/config.js";
import isEqual from "lodash/isEqual";
import { mapGetters } from "vuex";
import Editor from "@/views/blogs/Editor.vue";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      uploadedFile: "",
      checkChat: false,
      checkSms: false,
      tabs: null,
      isRelifeMember: "",
      isGeneric: "",
      onlyOnline: "",
      hospitalDelivery: "",
      workingHour: "",
      donorCard: "",
      ambulanceType: [],
      attachToHospital: "",
      outStationService: "",
      ambulanceServiceType: "",
      dialog: false,
      medicineBranches: medicineBranches,
      doctorQualifications: doctorQualifications,
      doctorSpecialities: [],
      branchOfMedicines: [],
      qualifications: [],
      specialities: [],
      userStatus: "",
      appliedFilters: {},
      value: [],
      searchTerm: "",
      role: "doctor",
      message: "",
      gender: "",
      userLocations: [],
      locations: [],
      userCount: 0,
      ambulanceType: [],
      reRender: true,
      filterItems: [
        { tabName: "Advanced Filter" },
        { tabName: "Search Users" },
      ],
      ambulanceTypeItem: [
        { name: "Basic", value: "Basic" },
        { name: "Basic with oxygen", value: "Basic with oxygen" },
        { name: "Cardiac", value: "Cardiac" },
        { name: "Hearse", value: "Hearse" },
        { name: "Air ambulance", value: "Air ambulance" },
        { name: "Motorcycle", value: "Motorcycle" },
      ],
      userStatusOption: [
        { name: "All", value: "" },
        { name: "Verified", value: "Verified" },
        { name: "Nonverified", value: "Nonverified" },
      ],
      singleSelectOption: [
        { name: "All", value: "" },
        { name: "Yes", value: true },
        { name: "No", value: false },
      ],
      pharmacyType: [],
      pharmacyTypesItems: [
        { name: "Allopathy", value: "Allopathy" },
        { name: "Homeopathy", value: "Homeopathy" },
        { name: "Ayurvedic", value: "Ayurvedic" },
      ],
      centerOwnership: [],
      centerOwnershipItems: [
        { name: "Private", value: "Private" },
        { name: "Charitable", value: "Charitable" },
        { name: "Government", value: "Government" },
      ],
      diagnosticServiceType: [],
      diagnosticServiceTypeItem: [
        { name: "Pathology", value: "Pathology" },
        { name: "Radiology", value: "Radiology" },
        { name: "Health Package", value: "Health Package" },
        { name: "CT scan", value: "CT scan" },
        { name: "Polyclinic", value: "Polyclinic" },
        { name: "MRI", value: "MRI" },
      ],
      bloodBankComponent: [],
      bloodBankComponentItem: [
        { name: "Whole Blood", value: "Whole Blood" },
        { name: "PRBC", value: "PRBC" },
        { name: "Single Donor Platelet", value: "Single Donor Platelet" },
        { name: "Random Donor Platelet", value: "Random Donor Platelet" },
        { name: "FFP", value: "FFP" },
        { name: "Cryoprecipitate", value: "Cryoprecipitate" },
      ],
      diagnosticServiceModeItem: [
        { name: "All", value: "" },
        { name: "Only Home service", value: "Only Home service" },
        { name: "Only Centre Service", value: "Only Centre Service" },
        {
          name: "Both Home & Centre service",
          value: "Both Home & Centre service",
        },
      ],
      diagnosticServiceMode: "",
      pharmacyServiceModeItem: [
        { name: "All", value: "" },
        { name: "Only Home Delivery", value: "Only Home Delivery" },
        { name: "Only Self Pickup", value: "Only Self Pickup" },
        {
          name: "Both Home Delivery & Self Pickup",
          value: "Both Home Delivery & Self Pickup",
        },
      ],
      pharmacyServiceMode: "",
      workingHourOption: [
        { name: "All", value: "" },
        { name: "Day", value: "Day" },
        { name: "Day&Night ", value: "Day&Night " },
      ],
      users: [],
      selectUser: [],
      search: "",
    };
  },
  mounted() {
    this.getSpecialities();
    this.getLocations();
    this.getUserCount();
  },
  watch: {
    search() {
      this.getUserList();
    },
  },
  methods: {
    checkIsPdf(url) {
      let extension = url.split(".").pop();
      return extension == "pdf";
    },
    updateMessage(message) {
      this.message = message;
    },
    getSpecialities() {
      let url = `${config.BASE_URL}api/v2/admin/doctor/master/specialities`;
      this.$http.get(url).then((response) => {
        let data = response.body.data;
        this.doctorSpecialities = data.map((text) => {
          text.speciality_type = text.speciality_type
            .toLowerCase()
            .split(" ")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" ");

          return text;
        });
      });
    },
    filterChanged(field, data) {
      if (field == "is_verified" && data != "") {
        this.appliedFilters[field] = data;
      } else if (this.appliedFilters[field] && data.length <= 0) {
        delete this.appliedFilters[field];
      } else if (data !== "") {
        this.appliedFilters[field] = data;
      } else {
        delete this.appliedFilters[field];
      }
      this.getUserCount();
    },
    getUserList() {
      let userParams = {
        page: 1,
        record_per_page: 10,
        user_name: this.search,
        role: this.role,
      };
      let url = `${config.BASE_URL}api/v2/admin/completed-role-users-listing`;
      let params = userParams;
      this.$http.get(url, { params }).then((res) => {
        if (res.status) {
          if (res && res.data && res.data.data && res.data.data.list.length) {
            this.users = res.data.data.list;
          } else {
            this.users = [];
          }
        } else {
          this.users = [];
        }
      });
    },
    removeFilter(field, index = 0) {
      if (field == "branch_of_medicine") {
        this.branchOfMedicines.splice(index, 1);
        this.removeObject(this.branchOfMedicines, "branch_of_medicine");
      } else if (field == "qualification") {
        this.qualifications.splice(index, 1);
        this.removeObject(this.qualifications, "qualification");
      } else if (field == "specialities") {
        this.specialities.splice(index, 1);
        this.removeObject(this.specialities, "specialities");
      } else if (field == "location") {
        this.locations.splice(index, 1);
        this.removeObject(this.locations, "location");
      } else if (field == "is_verified") {
        this.userStatus = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "gender") {
        this.gender = "";
        delete this.appliedFilters[field];
      } else if (field == "type_of_medicine") {
        this.pharmacyType.splice(index, 1);
        this.removeObject(this.pharmacyType, "type_of_medicine");
      } else if (field == "is_relife_member") {
        this.isRelifeMember = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "is_generic_store") {
        this.isGeneric = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "pharmacy_service_mode") {
        this.pharmacyServiceMode = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "diagnostic_service_mode") {
        this.diagnosticServiceMode = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "working_hour") {
        this.workingHour = "";
        delete this.appliedFilters[field];
        this.getUserCount();
      } else if (field == "bloodbank_services_offered") {
        this.bloodBankComponent.splice(index, 1);
        this.removeObject(
          this.bloodBankComponent,
          "bloodbank_services_offered"
        );
        this.getUserCount();
      } else if (field == "ownership_type") {
        this.centerOwnership.splice(index, 1);
        this.removeObject(this.centerOwnership, "ownership_type");
      } else if (field == "diagnostic_services_offered") {
        this.diagnosticServiceType.splice(index, 1);
        this.removeObject(
          this.diagnosticServiceType,
          "diagnostic_services_offered"
        );
      } else if (field == "ambulance_service_details") {
        this.ambulanceType.splice(index, 1);
        this.removeObject(this.ambulanceType, "ambulance_service_details");
      } else if (field == "is_attach_to_hospital") {
        this.attachToHospital = "";
        delete this.appliedFilters[field];
      } else if (field == "outstation") {
        this.outStationService = "";
        delete this.appliedFilters[field];
      } else if (field == "ambulance_type") {
        this.ambulanceServiceType = "";
        delete this.appliedFilters[field];
      } else if (field == "donor_card") {
        this.donorCard = "";
        delete this.appliedFilters[field];
      } else if (field == "hospital_delivery") {
        this.hospitalDelivery = "";
        delete this.appliedFilters[field];
      }
    },
    removeObject(field, objectKey) {
      if (field.length <= 0) delete this.appliedFilters[objectKey];
    },
    sendNotification() {
      let url = `${config.BASE_URL}api/v2/admin/system-notifications`;
      let filter;
      if (this.tabs) {
        filter = {
          user_ids: this.selectUser.map((d) => {
            return {
              _id: d._id,
              name: d.full_name,
            };
          }),
        };
      } else {
        filter = this.makeFilterRequest();
      }
      let input = {
        role: this.role,
        message: this.message,
        attachments: this.uploadedFile,
        filter: filter,
        send_chat: this.checkChat,
        send_sms: this.checkSms,
      };

      if (this.checkSms == true) {
        let text = this.message.replace(/<[^>]*>/g, '')
        // input.sms = text + " Team DocSmart support@docsmart.in . Download: https://api.docsmart.in/redirect-qrcode"
        input.sms = text
      }
      this.$http.post(url, input).then((response) => {
        if (response.body.status) {
          this.$swal("Notification success sent");
          this.reset();
        }
      });
    },
    getLocations() {
      let url = `${config.BASE_URL}api/v2/admin/user-locations`;
      let params = { role: this.role, location: "city" };
      if (this.searchTerm != "") {
        params.search = this.searchTerm;
      }
      this.$http.get(url, { params: params }).then((response) => {
        this.userLocations = response.body.data;
      });
    },
    searchLocations() {
      this.getLocations();
    },
    getFilenameFromURL(url) {
      const parsedUrl = new URL(url);
      const pathname = parsedUrl.pathname;
      return pathname.substring(pathname.lastIndexOf("/") + 1);
    },
    getUserCount() {
      let url = `${config.BASE_URL}api/v2/admin/user-count`;
      let filter = this.makeFilterRequest();
      let params = {
        role: this.role,
        filter: filter,
      };
      this.$http.get(url, { params: params }).then((response) => {
        this.userCount = response.body.data;
      });
    },
    makeFilterRequest() {
      let filter = this.appliedFilters;
      if (this.specialities.length > 0) {
        filter["specialities"] = filter["specialities"].map((speciality) => {
          return {
            speciality_id: speciality.speciality_id,
            speciality_type: speciality.speciality_type,
          };
        });
      }
      if (this.userStatus != "") {
        filter["is_verified"] = this.userStatus == "Verified" ? true : false;
      }
      return filter;
    },
    reset() {
      this.checkChat = false
      this.checkSms = false
      this.users = [];
      this.selectUser = []
      this.reRender = false
      this.branchOfMedicines = [];
      this.qualifications = [];
      this.specialities = [];
      this.uploadedFile = "",
      this.is_verified = "";
      this.gender = "";
      this.appliedFilters = {};
      this.locations = [];
      this.message = "";
      this.userStatus = "";
      this.getUserCount();
      this.isRelifeMember = "";
      this.isGeneric = "";
      this.onlyOnline = "";
      this.hospitalDelivery = "";
      this.workingHour = "";
      this.donorCard = "";
      this.ambulanceType = [];
      this.attachToHospital = "";
      this.outStationService = "";
      this.ambulanceServiceType = "";
      this.pharmacyServiceMode = "";
      this.ambulanceType = [];
      this.pharmacyType = [];
      this.centerOwnership = [];
      this.diagnosticServiceType = [];
      this.bloodBankComponent = [];
      this.diagnosticServiceMode = "";
      this.pharmacyServiceMode = "";
      this.$nextTick(() => {
        this.reRender = true;
      });
    },
    clearFilter() {
      this.branchOfMedicines = [];
      this.qualifications = [];
      this.specialities = [];
      this.is_verified = "";
      this.gender = "";
      this.userStatus = "";
      this.locations = [];
      this.appliedFilters = {};
      this.getUserCount();
    },
  },
  components: {
    ...pickSvg("filterSVG"),
    Editor,
  },
};
</script>
